// What a comparison is against, as a short caption: 'vs previous period',
// 'vs same period last year', 'vs a week before'… Undefined without one.
const describeComparison = (
  comparison: PersistedComparisonType | undefined,
): string | undefined => {
  if (!comparison) {
    return undefined;
  }
  switch (comparison.compareType) {
    case 'previous':
      // Back a whole interval rather than the period's length (a day back
      // is the same as the period's length)
      return comparison.compareByInterval &&
        comparison.compareByInterval !== 'day'
        ? `vs a ${comparison.compareByInterval} before`
        : 'vs previous period';
    case 'lastYear':
      return 'vs same period last year';
    case 'compareTo':
      return comparison.relativeDateOption
        ? `vs ${comparison.relativeDateOption}`
        : 'vs a chosen period';
    default:
      return undefined;
  }
};

export default describeComparison;
